import React, { Component } from "react";
import Select from "react-select";

function arrayDifference(array1, array2, commonProp) {
  // send backs an array containing items of array1 that are not present in array2
  // commonProp can be something like id
  if (!array1 || !array2) {
    return [];
  }
  return array1.filter(array1Item => {
    for (const item of array2) {
      if (array1Item[commonProp] === item[commonProp]) {
        return false;
      }
    }
    return true;
  });
}

class MultiSelectEditor extends Component {
  state = {
    value: this.props.value || [],
  };

  // static getDerivedStateFromProps(nextProps, prevState) {
  //   console.debug("getDerivedStateFromProps called");
  //   if (nextProps.value && nextProps.value.length !== prevState.value.length) {
  //     console.debug("getDerivedStateFromProps IFFIFIFIFIFIFIFFI called");
  //     console.debug("new props:::", nextProps.value);
  //     console.debug("prev state:::", prevState.value);
  //     return {
  //       value: nextProps.value
  //     };
  //   }
  //   return null;
  // }

  isPopup() {
    return true;
  }

  getValue() {
    // required by ag grid
    return this.state.value;
  }

  handleChangeInSelect = value => {
    if (this.props.fromPopup) {
      this.props.returnValue(value);
    } else {
      this.setState({ value });
    }
  };

  render() {
    console.debug(this.props);
    const remainingOptions = arrayDifference(
      this.props.options,
      this.state.value,
      "id",
    );
    // console.debug("All Options:::", this.props.options);
    // console.debug("Currently Selected:::", this.state.value);
    // console.debug("Remaining Options:::", remainingOptions);
    return (
      <Select
        // styles={customStyles}
        // autoFocus={true}
        defaultValue={this.state.value}
        isMulti
        options={remainingOptions}
        closeMenuOnSelect={false}
        onChange={value => this.handleChangeInSelect(value)}
      />
    );
  }
}

// const mapStateToProps = state => {
//   const bundlesOptions = state.bundlesData ? state.bundlesData : [];
//   return { bundlesOptions };
// };

// export default connect(
//   mapStateToProps,
//   null
// )(MultiSelectEditor);

export default MultiSelectEditor;



// WEBPACK FOOTER //
// ./src/components/cell-editors/MultiSelectEditor.js